/**
 * AUD-023 (cosmetic, lowest priority in the audit) — no page offered a way
 * to bypass the header/nav and jump straight to page content. Now that
 * AUD-016/017 established real <h1>/<main> landmarks to skip *to* on every
 * page that has a header worth bypassing, this is a small, self-contained
 * addition: visually hidden until it receives keyboard focus (the standard
 * "skip link" pattern), then it's the very first focusable thing on the
 * page.
 *
 * Not added to LoginPage — its header is just a logo/tagline, not
 * navigation, so there's nothing meaningful to skip past there.
 */
import styles from "./SkipLink.module.css";

interface SkipLinkProps {
  targetId: string;
}

export function SkipLink({ targetId }: SkipLinkProps) {
  return (
    <a href={`#${targetId}`} className={styles.skipLink}>
      Skip to main content
    </a>
  );
}
